import { useEffect } from 'react'

import { EVENT_NAME_CLICK } from '../constants/event'

export function useClickOutside(ref, onClickOut) {
  useEffect(() => {
    if (ref?.current && onClickOut) {
      function handleClick(e) {
        if (ref.current && !ref.current.contains(e.target)) {
          onClickOut()
        }
      }

      document.addEventListener(EVENT_NAME_CLICK, handleClick)

      return function cleanup() {
        document.removeEventListener(EVENT_NAME_CLICK, handleClick)
      }
    }
  }, [onClickOut, ref])
}
